
import { Link } from 'react-router-dom';
import { CheckCircle, Calendar, Users, Trophy, ArrowRight } from 'lucide-react';

const FeatureCard = ({ icon, title, description }: { icon: React.ReactNode; title: string; description: string }) => (
  <div className="text-center p-6 rounded-lg border border-gray-100 bg-white shadow-sm hover:shadow-md transition-shadow">
    <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-blue-50 text-realestate-blue mb-4">
      {icon}
    </div>
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-gray-600">{description}</p>
  </div>
);

const WhyChooseUs = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-realestate-darkblue mb-2">Why Choose PropertyLK</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">We provide exceptional commercial real estate services powered by industry expertise and cutting-edge technology</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <FeatureCard 
            icon={<CheckCircle className="h-7 w-7" />}
            title="Verified Listings"
            description="All properties are verified by our team to ensure accurate information"
          />
          
          <FeatureCard 
            icon={<Calendar className="h-7 w-7" />}
            title="Fast Transactions"
            description="We streamline the process to help you buy, sell, or lease properties quickly"
          />
          
          <FeatureCard 
            icon={<Trophy className="h-7 w-7" />}
            title="Market Expertise"
            description="Our team has deep knowledge of commercial real estate markets"
          />
          
          <FeatureCard 
            icon={<Users className="h-7 w-7" />}
            title="Dedicated Support"
            description="Get personalized assistance throughout your property journey"
          />
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/contact" className="inline-flex items-center text-realestate-blue hover:text-realestate-darkblue font-medium">
            Learn more about our services
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
